<template>
    <div>
        <slot
            name="button"
            btn
            btn-rounded
            arclight
            :editable="editable"
            :activate="activate"
        >
            <button
                id="btn-add"
                class="btn btn-rounded arclight"
                :disabled="!editable"
                @click="activate"
            >
                <slot name="button-content">
                    <i class="icon-add"></i>
                    <span>Add</span>
                </slot>
            </button>
        </slot>
        <bo-popup-modal
            :title="title"
            modalStyle="full-width has-table"
            :active="active"
            :append-to-body="appendToBody"
            @activate="activate"
            @deactivate="deactivate"
            @trigger="$emit('trigger', ...arguments)"
        >
            <template slot="body-content">
                <slot name="content"> </slot>
            </template>
            <template slot="header-content">
                <slot name="header"> </slot>
            </template>
        </bo-popup-modal>
    </div>
</template>

<script>
import boPopupModal from "@/v2/components/bo-popup-modal.vue";

export default {
    components: { boPopupModal },
    props: {
        appendToBody: {
            type: Boolean,
            default: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            active: false,
        };
    },
    methods: {
        activate() {
            this.active = true;
            this.$emit("activate");
        },
        deactivate() {
            this.active = false;
        },
    },
};
</script>
